<template>
  <div v-if="openModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-container">
      <div class="card p-3">
        <div class="d-flex justify-content-between mb-5">
          <h4>Smartcat Overview</h4>
          <button class="close-btn" @click="closeModal">&times;</button>
        </div>

        <tabs tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper mt-0"
          style="margin-top: -40px!important;padding-top: 0px!important;">
          <tab-pane>
            <span slot="title"><i class="fas fa-home"></i> OVERVIEW</span>
            <div v-if="!loadDetail" class="modal-body-scroll">
              <div class="p-3 bg-primary text-white text-center mb-3">
                <h2 class="mt-2 text-white">{{ detailSmartcat?.short_description }}</h2>
              </div>
              <div class="d-flex mt-4 w-full mb-3">
                <div class=" bg-success text-white py-4 text-center" style="width: 25%;">
                  <span style="font-size: 11px;">PLANT</span>
                  <br>
                  <span style="font-size: 20px;">{{ detailSmartcat?.plant_code }}</span>
                </div>
                <div class="bg-primary text-white py-4 ml-3 text-center" style="width: 25%;">
                  <span style="font-size: 11px;">CATALOG STATUS</span>
                  <br>
                  <span style="font-size: 20px;">{{ detailSmartcat?.cat_status_code }}</span>
                </div>
                <div class="bg-danger text-white py-4 ml-3 text-center" style="width: 25%;">
                  <span style="font-size: 11px;">CATALOG TYPE</span>
                  <br>
                  <span style="font-size: 20px;">{{ detailSmartcat?.item_type_code }}</span>
                </div>
                <div class="bg-warning text-white py-4 ml-3 text-center" style="width: 25%;">
                  <span style="font-size: 11px;">MATERIAL NUMBER</span>
                  <br>
                  <span style="font-size: 20px;">{{ detailSmartcat?.material_number }}</span>
                </div>
                <div class="bg-warning text-white py-4 ml-3 text-center" style="width: 25%;">
                  <span style="font-size: 11px;">UNRESTRICTED USED</span>
                  <br>
                  <span style="font-size: 20px;">
                     <span style="font-size: 30px;">
                      {{ getOverViewStock(detailSmartcat?.stocks_detail) }}
                    </span>
                  </span>
                </div>
                <div class="bg-warning text-white py-4 ml-3 text-center" style="width: 25%;">
                  <span style="font-size: 11px;">MATERIAL TYPE</span>
                  <br>
                  <span style="font-size: 20px;">
                     <span style="font-size: 30px;">
                      {{ detailSmartcat?.mtype_code}}
                    </span>
                  </span>
                </div>
              </div>

              <div class="mb-2">
                <h5>MCR NUMBER</h5>
                <el-input type="text" v-model="detailSmartcat.mcr_number" size="large" disabled></el-input>
              </div>

              <div class="mb-2">
                <h5>OLD MATEIRAL NUMBER</h5>
                <el-input type="text" v-model="detailSmartcat.old_material_number" size="large" disabled></el-input>
              </div>

              <div class="mb-2">
                <h5>LONG DESCRIPtiON</h5>
                <el-input type="text" v-model="detailSmartcat.long_description" size="large" disabled></el-input>
              </div>

              <div class="mb-2">
                <h5>CRETAED SAP</h5>
                <el-input type="text" v-model="detailSmartcat.created_sap" size="large" disabled></el-input>
              </div>

              <div class="table-responsive">
                <h5>CHARACTERISTICS</h5>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">CHARACTERISTICS</th>
                      <th scope="col">VALUE</th>
                      <th scope="col">ABBREV</th>
                      <th scope="col">VIEW</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="char_value in detailSmartcat?.char_values">
                      <th class="text-uppercase">{{ char_value?.characteristic}}</th>
                      <td class="text-uppercase">{{ char_value?.characteristic_value }}</td>
                      <td class="text-uppercase">{{ char_value?.abbreviation }}</td>
                      <td class="text-uppercase text-center">
                        <el-checkbox
                          v-if="char_value?.view == 'checked'"
                          disabled
                          checked
                        ></el-checkbox>
                        <el-checkbox
                          v-if="char_value?.view != 'checked'"
                          disabled
                        ></el-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
            <skeleton-loading v-else />
          </tab-pane>

          <tab-pane>
            <span slot="title"><i class="fas fa-info-circle"></i> INFORMATION</span>
            <div class="modal-body-scroll" v-if="!loadDetail">

              <div class="table-responsive mb-3">
                <h5>REFERENCES</h5>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">CODE</th>
                      <th scope="col">SOURCE</th>
                      <th scope="col">MANUFACTURE REFERENCE</th>
                      <th scope="col">TYPE</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="manufacture_ref in detailSmartcat?.manufacture_refs">
                      <th class="text-uppercase">{{ manufacture_ref?.manufacture_code}}</th>
                      <td class="text-uppercase">{{ manufacture_ref?.source_type_code }}</td>
                      <td class="text-uppercase">{{ manufacture_ref?.manufacture_ref }}</td>
                      <td class="text-uppercase">{{ manufacture_ref?.manref_type_code }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="mb-2">
                <h5>ITEM NAME / INC</h5>
                <el-input type="text" v-model="detailSmartcat.item_name" size="large" disabled></el-input>
              </div>

              <div class="mb-2">
                <h5>GROUP CLASS / NCS</h5>
                <el-input type="text" v-model="detailSmartcat.mgroup_name" size="large" disabled></el-input>
              </div>

            </div>
            <skeleton-loading v-else />
          </tab-pane>

          <tab-pane>
            <span slot="title"><i class="fas fa-flag"></i> FLAGS</span>
            <div class="modal-body-scroll" v-if="!loadDetail">

              <div class="table-responsive mb-3">
                <h5>SLOCS</h5>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">PLANT</th>
                      <th scope="col">LOCATION</th>
                      <th scope="col">SHELF</th>
                      <th scope="col">BIN</th>
                    </tr>
                  </thead>
                    <tr v-for="sloc in detailSmartcat?.slocs">
                      <td class="text-uppercase">{{ sloc?.plant_code}}</td>
                      <td class="text-uppercase">{{ sloc?.location_code }}</td>
                      <td class="text-uppercase">{{ sloc?.shelf_code }}</td>
                      <td class="text-uppercase">{{ sloc?.bin_code }}</td>
                    </tr>
                  <tbody>
                  </tbody>
                </table>
              </div>

              <div class="table-responsive mb-3">
                <h5>ACCOUNTING</h5>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">VALUATION CLASS</th>
                      <th scope="col">VALUATION CATEGORY</th>
                      <th scope="col">VALUATION TYPE</th>
                    </tr>
                  </thead>
                    <tr v-for="acc in detailSmartcat?.accountings">
                      <td class="text-uppercase">{{ `${acc?.valuation_class_code} - ${acc?.class_description}`}}</td>
                      <td class="text-uppercase">{{ `${acc?.valuation_category_code} - ${acc?.valuation_category_description}` }}</td>
                      <td class="text-uppercase">{{ `${acc?.valuation_type_code}` }}</td>
                    </tr>
                  <tbody>
                  </tbody>
                </table>
              </div>

            </div>
            <skeleton-loading v-else />
          </tab-pane>

          <tab-pane>
            <span slot="title"><i class="fas fa-cogs"></i> EQUIPMENTS</span>
            <div class="modal-body-scroll" v-if="!loadDetail">

              <div class="table-responsive mb-3">
                <h5>EQUIPMENTS</h5>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">EQUIPMENT CODE</th>
                      <th scope="col">EQUIPMENT NAME</th>
                      <th scope="col">QUANTITY INSTALLED</th>
                    </tr>
                  </thead>
                    <tr v-for="equipment in detailSmartcat?.equipments">
                      <th class="text-uppercase">{{ equipment?.equipment_code}}</th>
                      <td class="text-uppercase">{{ equipment?.equipment_name }}</td>
                      <td class="text-uppercase">{{ equipment?.qty_installed }}</td>
                    </tr>
                  <tbody>
                  </tbody>
                </table>
              </div>

            </div>
            <skeleton-loading v-else />
          </tab-pane>

          <tab-pane>
            <span slot="title"><i class="fas fa-paragraph"></i> PO TEXT</span>
            <div class="modal-body-scroll" v-if="!loadDetail">
             
                <div class="mb-2">
                  <h5>PO TEXT MCR</h5>
                  <el-input type="textarea" v-model="detailSmartcat.po_text" :placeholder="tt('po_text')" size="large"
                  resize="vertical" :autosize="true" disabled></el-input>
                </div>

                <div class="mb-2">
                  <h5>PO TEXT EXISTING SAP</h5>
                  <el-input type="textarea" v-model="detailSmartcat.po_text_sap" :placeholder="tt('po_text')" size="large"
                  resize="vertical" :autosize="true" disabled></el-input>
                </div>

                <!-- <div class="mb-2">
                  <h5>LATEST UPDATE SAP</h5>
                  <el-input type="text" v-model="detailSmartcat.latest_date_po_text_sap" size="large" disabled></el-input>
                </div> -->

            </div>
            <skeleton-loading v-else />
          </tab-pane>

          <tab-pane>
            <span slot="title"><i class="fas fa-copy"></i> DOCUMENTS</span>
            <div class="modal-body-scroll" v-if="!loadDetail">

              <div class="table-responsive mb-3">
                <h5>DOCUMENTS</h5>
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 15%!important;">CODE</th>
                      <th scope="col">DESCRIPTION</th>
                      <th scope="col" style="width: 10%!important;">DATE CREATED</th>
                    </tr>
                  </thead>
                    <tr v-for="attcahment in detailSmartcat?.attcahments">
                      <th class="text-uppercase">
                        <a :href="attcahment?.file_attachment_code" target="_blank" style="cursor: pointer;">
                          {{ getShortAttachmentCode(attcahment?.file_attachment_code)}}
                        </a>
                      </th>
                      <td class="text-uppercase">{{ attcahment?.attachment_description }}</td>
                      <td class="text-uppercase">{{ attcahment?.created_at }}</td>
                    </tr>
                  <tbody>
                  </tbody>
                </table>
              </div>

            </div>
            <skeleton-loading v-else />
          </tab-pane>
          
          <tab-pane>
            <span slot="title"><i class="fas fa-copy"></i> STOCK PER SLOC</span>
            <div class="modal-body-scroll" v-if="!loadDetail">
               <div class="bg-primary text-white mb-3 rounded p-3" v-for="sloc in detailSmartcat.stocks_detail">
                <span class="font-weight-bold">{{ formatingTonnage(sloc.labst) }} {{ sloc.meins }}</span>
                <br>
                <span>{{ sloc.lgort }} {{ sloc.bin_code }}</span>
              </div>
            </div>
            <skeleton-loading v-else />
          </tab-pane>

        </tabs>
      </div>
      
    </div>
  </div>
</template>

<script>
import Api from '@/helpers/api';
import tomatSearchService from '@/services/master/tomatSearch';

export default {
  name: "TomatModalDetail",
  props: ['showModal', 'sourceData'],
  data() {
    return {
      openModal: false,
      loadDetailStock: false,
      loadDetail: false,
      detailSmartcat: {
        stocks_detail: []
      }
    }
  },
  methods: {
    getOverViewStock(stocks)
    {
        const stock = stocks.length > 0 ? stocks[0]?.labst : '0'
        const unit = stocks.length > 0 ? stocks[0]?.meins : ''
        const formatingTonnage = this.formatingTonnage(stock)

        return `${formatingTonnage} ${unit}`
    },
    getShortAttachmentCode(str) {
      return str.length > 50 ? str.substring(0, 50) + "..." : str;
    },
    formatingTonnage(tonnage)
    {
        const tonnage_splitted = tonnage.split('.');
        
        if (tonnage_splitted.length == 1) return tonnage

        const last_digit = tonnage_splitted[tonnage_splitted.length - 1]

        tonnage_splitted.pop()

        const formatting_tonnage = parseInt(tonnage_splitted.join(""), 10).toLocaleString("id-ID");

        return last_digit == 0 ? formatting_tonnage : `${formatting_tonnage},${last_digit}`
    },
    getDetail() {
      this.loadDetailStock = true
      this.openModal = true

      Api(this, tomatSearchService.detailSmartcat({ plant: this.sourceData?.plant_code, material_number: this.sourceData?.material_number }))
        .onSuccess(response => {

          const detailSmartcat = response.data.data
          this.detailSmartcat = { 
            ... detailSmartcat, 
            po_text_sap: detailSmartcat?.po_texts.map(m => m.po_text).join("\n"),
            latest_date_po_text_sap: detailSmartcat?.po_texts[0]?.middle_db_created_date ?? '-'
          }

        }).onError(error => {
          this.detailSmartcat = null
        }).call();
    },
    closeModal() {
      this.openModal = false
      this.$emit('close-modal')
    }
  },
  watch: {
    showModal(val) {
      if (val) this.getDetail()
    }
  },
};
</script>

<style>

body {
  overflow: auto !important;
}

.modal-overlay {
position: fixed;
inset: 0;
background: rgba(0,0,0,0.5);
display: flex;
justify-content: center;
align-items: flex-start;
padding-top: 40px;
z-index: 9999;
}


.modal-container {
width: 80%;
/* max-width: 600px; */
background: white;
border-radius: 10px;
overflow: hidden;
margin: 0 auto;
animation: modalFade 0.35s ease;
}


.modal-left {
  width: 95%;
  margin-top: -40px!important;
}


.modal-right {
  width: 35%;
  margin-top: -40px!important;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 28px;
  background: none;
  border: none;
  cursor: pointer;
  color: #000;
  opacity: 0.5;
  transition: opacity 0.2s ease;
  margin-top: -10px !important;
}

.close-btn:hover {
  opacity: 0.75;
}

.modal-body-scroll {
    overflow-y: auto!important;
    max-height: 800px!important;
}

thead th {
  font-size: 13px!important;
  font-weight: 600;
}

tbody td,
tbody th {
  font-size: 15px!important;
}

@keyframes modalFade {
  0% { 
    opacity: 0; 
    transform: translateY(-20px); 
  }
  100% { 
    opacity: 1; 
    transform: translateY(0); 
  }
}

</style>
